import PinterestGlobalPixel from './PinterestGlobalPixel';

export default PinterestGlobalPixel;
